import React from "react";
import ChangeUserEmailModal from "components/Admin/ChangeUserEmailModal/ChangeUserEmailModal";
import DataTable from "components/common/DataTable/DataTable";
import WarningModal from "components/common/Modals/WarningModal";
import { IUser } from "core/types/base/IUser";
import Svg from "components/common/SVG/Svg";
import useAdminManagement from "hooks/tenant/useAdminManagement";
import AdminsManagementTableColumns from "components/tenants/AdminsManagementTableColumns";
import AddEditAdminModal from "components/features/AddEditAdminModal";

const AdminManagementScreen = () => {
  const {
    users,
    modals,
    toggleModal,
    createEditUser,
    handleConfirmUserAction,
    handleUserAction,
    getUsers,
    modalTitle,
    selectedEntity,
    changeUserEmail,
  } = useAdminManagement({
    fetchOnLoad: true,
  });

  const { addUser, warningPassword, warningStatus, editUser, sendInvite, changeEmail } = modals;

  return (
    <div className="row">
      <div className="col-12 d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 className="mb-0 me-3">Manage Global Admins</h4>
        <button
          type="button"
          title="Create Admin"
          className="btn btn-sm btn-success"
          onClick={() => handleUserAction("addUser", {} as IUser)}
        >
          <Svg icon="create" width={15} height={15} color="#ffffff" />
          <span className="ms-2">Create</span>
        </button>
      </div>

      <div className="col-12 mx-auto mb-5">
        <div className="card shadow-lg">
          <DataTable
            tableData={users}
            tableColumns={AdminsManagementTableColumns({
              handleDropdownAction: (row, event, actionKey) =>
                handleUserAction(actionKey, row, event),
            })}
            onSort={(key) => getUsers(key)}
            tableClassName="table-striped mb-0"
            classContainer="table-responsive"
          />
        </div>
      </div>
      {/* Start Modals */}
      <AddEditAdminModal
        showModal={addUser || editUser}
        onCancel={() => toggleModal({ hideAll: true })}
        onClose={() => toggleModal({ hideAll: true })}
        onSave={(user) => user && createEditUser(user)}
        user={selectedEntity || ({} as IUser)}
        modalTitle={modalTitle}
        // Don't pass tenantId for global admins - this will fetch all roles
      />

      <ChangeUserEmailModal
        showModal={changeEmail}
        onCancel={() => toggleModal({ hideAll: true })}
        onClose={() => toggleModal({ hideAll: true })}
        onSave={(data) => data && changeUserEmail(data)}
        user={selectedEntity || ({} as IUser)}
        modalTitle={modalTitle}
      />

      <WarningModal
        showModal={warningStatus || warningPassword || sendInvite}
        onClose={() => toggleModal({ hideAll: true })}
        onCancel={() => toggleModal({ hideAll: true })}
        onSave={() => handleConfirmUserAction()}
        modalTitle={modalTitle}
      />
      {/* End Modals */}
    </div>
  );
};

export default AdminManagementScreen;
